import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AnonymousAccountTrackingLocation } from '../types';
import META from './useTrackLoggedInToAnonymousAccount.meta';

export type TrackLoggedInToAnonymousAccountParams = {
  share_url: string;
  object_id: string;
  object_type: 'clip' | 'board' | 'collection' | 'canvas';
  location: AnonymousAccountTrackingLocation;
};

export const useTrackLoggedInToAnonymousAccount = () => {
  const { track } = useAnalyticsUtilities();

  const trackLoggedInToAnonymousAccount = useCallback(
    (params: TrackLoggedInToAnonymousAccountParams) => {
      track(META.name, params);
    },
    [track],
  );

  return {
    trackLoggedInToAnonymousAccount,
  };
};
